import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { AreaAgentOptionType, AreaType, CommunityOptionType } from './types.ts'

interface EditProps {
  area: AreaType
  agents?: AreaAgentOptionType[]
  communities?: CommunityOptionType[]
  can_select_community?: boolean
}

export default function Edit({ area, agents = [], communities = [], can_select_community = false }: EditProps) {
  return (
    <>
      <Head title="Editing area" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing area</h1>

        <Form
          area={area}
          agents={agents}
          communities={communities}
          can_select_community={can_select_community}
          action={`/admin/areas/${area.id}`}
          method="patch"
          submitText="Mettre à jour la zone"
        />

        <Link
          href={`/areas/${area.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Voir cette zone
        </Link>
        <Link
          href="/areas"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux zones
        </Link>
      </div>
    </>
  )
}
